import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";

const UOMPopup = ({ data }) => {
  return (
    <div className="w-full">
      <div className="mx-auto flex justify-center lg:w-2/5 md:w-full w-full">
        <div className="relative w-full h-full max-w-xl md:h-auto">
          <div className="relative bg-white rounded-lg shadow">
            <div className="px-6 py-6 lg:px-8">
              <form className="space-y-6">
                <InputText
                  inputType="text"
                  classStar="text-red-500"
                  title="Unit of Measure"
                  name="Unit of Measure"
                  content={data?.CommodityUOM}
                  disabled={true}
                />

                <TextArea
                  title="Description"
                  name="Description"
                  rows={4}
                  content={data?.Description}
                  disabled={true}
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UOMPopup;
